var _defs, _rect, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuurzameOplossing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20 0 L 0 0 0 20",
    fill: "none",
    stroke: "#f0f0f0",
    strokeWidth: 1
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#grid)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 80,
    fill: "none",
    stroke: "#EE3124",
    strokeWidth: 3,
    strokeDasharray: "8 4"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 20,
    fill: "#2B4055"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontSize: 12
  }, "Plan")), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 20,
    fill: "#2B4055"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontSize: 12,
    transform: "rotate(-90 60 0)"
  }, "Do")), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(180)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 20,
    fill: "#2B4055"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontSize: 12,
    transform: "rotate(-180 60 0)"
  }, "Check")), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(270)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 0,
    r: 20,
    fill: "#2B4055"
  }), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 5,
    textAnchor: "middle",
    fill: "white",
    fontSize: 12,
    transform: "rotate(-270 60 0)"
  }, "Act")), /*#__PURE__*/React.createElement("path", {
    d: "M 40 -40 L 80 -80",
    stroke: "#EE3124",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 40 40 L 80 80",
    stroke: "#EE3124",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -40 -40 L -80 -80",
    stroke: "#EE3124",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -40 40 L -80 80",
    stroke: "#EE3124",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -90 -90 Q -70 -100 -50 -90 T -10 -90",
    fill: "none",
    stroke: "#4CAF50",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10 90 Q 30 80 50 90 T 90 90",
    fill: "none",
    stroke: "#4CAF50",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -120,
    cy: -120,
    r: 15,
    fill: "#EE3124",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 120,
    r: 15,
    fill: "#EE3124",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -120,
    cy: 120,
    r: 15,
    fill: "#EE3124",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: -120,
    r: 15,
    fill: "#EE3124",
    opacity: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(200 150)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 5,
    fill: "#EE3124"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 10,
    fill: "none",
    stroke: "#EE3124",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuurzameOplossing);
export default __webpack_public_path__ + "static/media/DuurzameOplossing.8075ab4f4f3aea425653ae7a28e5f038.svg";
export { ForwardRef as ReactComponent };